import React from "react";
import s from './New.module.css'

const New = (props) => {
    return (
        <div className={s.item}>
            New
        </div>
    )
}

export default New;